/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-south-1",
    "aws_appsync_graphqlEndpoint": "https://kolkcpr73vbg3posc5ivravpna.appsync-api.ap-south-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-south-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-yuhzbavulvb5nonvnbnhqcc6oi",
    "aws_cognito_identity_pool_id": "ap-south-1:b5e9ee1c-f14f-4912-81b3-eb444955227e",
    "aws_cognito_region": "ap-south-1",
    "aws_user_pools_id": "ap-south-1_3vsdiBzYy",
    "aws_user_pools_web_client_id": "37blum6lrf1k3030hglpo1tfbv",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "getscreenedstoragebucket7e1c9-stage",
    "aws_user_files_s3_bucket_region": "ap-south-1"
};


export default awsmobile;
